import React, { useState } from "react";
import { store } from "./components/Store";
import {useContext, useEffect} from 'react';
import { SesionAPI } from "./services/api/Sesion";
import { useHistory, useLocation } from "react-router-dom";
import { CancelRequestController } from "./util/cancel-request-controller";

/**
 * Componente que actúa como wrapper el cual verifica el estado de la sesión del usuario y manipula el dom dependiendo del estado, este componente es importante para la seguridad de los datos en el frontend.
 * @param {object} children 
 * @returns {JSX.Element} VerificarSesion
 */
export const VerificarSesion = ({children})=>{
  const location = useLocation();
  const history = useHistory();
  const {state, dispatch} = useContext(store);
  const [validationFinished, setValidationFinished] = useState(false);

  const verificar = async ({abortSignal})=>{
    await SesionAPI.usuarioAutenticado({abortSignal})
    .then(res=>{
      if (res===false && state.sesionActiva === 'SI'){
        localStorage.clear();
        window.location.reload();
      }
    })
    .catch(err=>err)
    .finally(()=>{
      setValidationFinished(true);
    })
  }

  useEffect(()=>{
    const abortController = new CancelRequestController();
    verificar({abortSignal:abortController.signal})
    return ()=>{
      abortController.abort();
    }
  },[state.sesionActiva, location.pathname])

  // Importante mantener este conditional rendering.
  return (<>
  {validationFinished?children:<></>}
  </>)
}
